export const getEsignTemplatesData = state => state.esignTemplates.all;
export const getEsignTemplateData = state => state.esignTemplates.esignTemplate;
export const esignTemplatesIsFetching = state => state.esignTemplates.loading.all;
export const esignTemplateIsFetching = state => state.esignTemplates.loading.esignTemplate;